/* eslint-disable @typescript-eslint/camelcase */
const Popover = require('airship/widgets/popover/base').Popover

const createHelpText = () => {
  const div = document.createElement('div')
  div.setAttribute('class', 'help-text')
  const arrow = document.createElement('span')
  arrow.setAttribute('class', 'arrow up')
  const helpText = document.createTextNode('')

  div.appendChild(arrow)
  div.appendChild(helpText)
  return {div, setHelpText: (text) => (helpText.nodeValue = text)}
}

let is_listening = false
let popover
let setHelpText

window.$(document).ready(() => {
  popover = new Popover({className: 'popover tooltip'})

  const helpText = createHelpText()
  popover.el.append(helpText.div)
  setHelpText = helpText.setHelpText

  window
    .$('body')
    .on('mouseenter', '[data-help]', show_tooltip)
    .on('mouseleave', '[data-help]', hide_tooltip)
    .on('click', '[data-help]', function (ev) {
      hide_tooltip()
      if (ev.currentTarget.getAttribute('href') === '#') {
        ev.preventDefault()
      }
    })
})

function show_tooltip(ev) {
  // make sure our element is always last.
  popover.el.appendTo('body')

  const el = window.$(ev.currentTarget),
    text = el.attr('data-help')

  setHelpText(text)

  if (text) {
    popover.open(el)
  }

  is_listening = true
}

function hide_tooltip() {
  if (!is_listening) {
    return
  }

  is_listening = false

  popover.close()
}
